import PeriodStatistic from './PeriodStatistic';

export default PeriodStatistic;